import { apiClient } from './client.js';
import type { PricingRule, CreatePricingRuleInput, UpdatePricingRuleInput } from '@atomfit/shared';
import type { PaginatedResult } from '../types/index.js';

function tenantHeaders(tenantSlug?: string) {
  return tenantSlug ? { headers: { 'X-Tenant-ID': tenantSlug } } : undefined;
}

export interface PricingRuleWithGym extends PricingRule {
  gym: { id: string; name: string; slug: string } | null;
}

export interface PricingAuditLog {
  id: string;
  action: string;
  entityType: string;
  entityId: string;
  createdAt: string;
  actor: { email: string; firstName: string | null; lastName: string | null } | null;
}

export const pricingApi = {
  list: (gymId?: string, page = 1) =>
    apiClient.get<PaginatedResult<PricingRuleWithGym>>('/owner/pricing-rules', {
      params: { ...(gymId ? { gymId } : {}), page },
    }),

  create: (data: CreatePricingRuleInput) =>
    apiClient.post<PricingRule>('/owner/pricing-rules', data),

  update: (ruleId: string, data: UpdatePricingRuleInput) =>
    apiClient.put<PricingRule>(`/owner/pricing-rules/${ruleId}`, data),

  delete: (ruleId: string) =>
    apiClient.delete(`/owner/pricing-rules/${ruleId}`),

  audit: (page = 1, gymId?: string) =>
    apiClient.get<PaginatedResult<PricingAuditLog>>('/owner/pricing-rules/audit', {
      params: { page, limit: 10, ...(gymId ? { gymId } : {}) },
    }),
};

export const operatingHoursApi = {
  list: (gymId: string, tenantSlug?: string) =>
    apiClient.get<{ data: { id: string; gymId: string; dayOfWeek: number; openTime: string; closeTime: string; isClosed: boolean }[] }>(
      `/owner/gyms/${gymId}/operating-hours`,
      tenantHeaders(tenantSlug),
    ),

  upsert: (gymId: string, hours: { dayOfWeek: number; openTime: string; closeTime: string; isClosed: boolean }[], tenantSlug?: string) =>
    apiClient.put<{ data: { id: string; gymId: string; dayOfWeek: number; openTime: string; closeTime: string; isClosed: boolean }[] }>(
      `/owner/gyms/${gymId}/operating-hours`,
      { hours },
      tenantHeaders(tenantSlug),
    ),
};
